import React, { useState } from 'react';

const CAP = 280;
const initialBuses = [
  {id:'FA6AF3D9',nombre:'Bus 01',cop:'Fontibón',soc:82,limite:90},
  {id:'B3C21AE7',nombre:'Bus 02',cop:'Fontibón',soc:45,limite:90},
  {id:'D9F045CC',nombre:'Bus 03',cop:'Usme',soc:61,limite:90},
  {id:'1A2B3C4D',nombre:'Bus 04',cop:'Usme',soc:23,limite:90},
  {id:'E7F8A912',nombre:'Bus 05',cop:'Fontibón',soc:90,limite:90},
  {id:'C0DE1234',nombre:'Bus 06',cop:'Usme',soc:38,limite:90},
  {id:'AABB5566',nombre:'Bus 07',cop:'Fontibón',soc:55,limite:90},
  {id:'FF001122',nombre:'Bus 08',cop:'Usme',soc:12,limite:90},
  {id:'11223344',nombre:'Bus 09',cop:'Fontibón',soc:77,limite:90},
  {id:'55667788',nombre:'Bus 10',cop:'Usme',soc:68,limite:90},
];

export default function Gestion() {
  const [buses, setBuses] = useState(initialBuses);
  const [globalLimit, setGlobalLimit] = useState(90);

  const energEst = (soc,lim) => lim<=soc ? 0 : Math.round((lim-soc)/100*CAP);
  const tiempoEst = kwh => { if(kwh<=0)return'—'; const m=Math.round(kwh/135*60); return m>=60?`${Math.floor(m/60)}h ${String(m%60).padStart(2,'0')}m`:`${m} min`; };
  const socColor = s => s>=75?'#4ade80':s>=40?'#60a5fa':'#f59e0b';

  const applyGlobal = () => setBuses(b => b.map(bus => ({...bus, limite: globalLimit})));
  const updateLimit = (i, val) => {
    const v = Math.max(50, Math.min(100, parseInt(val)||90));
    setBuses(b => b.map((bus,idx) => idx===i ? {...bus, limite:v} : bus));
  };

  const totalE = buses.reduce((a,b) => a + energEst(b.soc,b.limite), 0);
  const prioritarios = buses.filter(b => b.soc < 30);

  const getTag = (soc, lim) => {
    if(lim <= soc) return <span className="tag tag-available">Completo</span>;
    if(soc < 30) return <span className="tag tag-faulted">Prioritario</span>;
    return <span className="tag tag-charging">Pendiente</span>;
  };

  return (
    <div>
      <div className="page-title">Gestión de carga</div>
      <div className="metrics">
        <div className="metric-card"><div className="metric-label">Buses en flota</div><div className="metric-value">{buses.length}</div></div>
        <div className="metric-card"><div className="metric-label">Energía total a cargar</div><div className="metric-value">{totalE.toLocaleString()} kWh</div></div>
        <div className="metric-card"><div className="metric-label">Buses completos</div><div className="metric-value" style={{color:'#4ade80'}}>{buses.filter(b=>b.limite<=b.soc).length}</div></div>
        <div className="metric-card"><div className="metric-label">Buses prioritarios</div><div className="metric-value" style={{color:'#f87171'}}>{prioritarios.length}</div></div>
      </div>
      {prioritarios.length > 0 && (
        <div className="alert">⚠ Atención: {prioritarios.map(b=>b.nombre).join(', ')} {prioritarios.length===1?'tiene':'tienen'} SoC bajo 30%. Carga prioritaria recomendada.</div>
      )}
      <div className="card" style={{marginBottom:'1.25rem'}}>
        <div className="card-title">Límite global para toda la flota</div>
        <div className="slider-wrap">
          <label>Cargar todos los buses hasta:</label>
          <input type="range" min="50" max="100" value={globalLimit} onChange={e=>setGlobalLimit(parseInt(e.target.value))} />
          <span className="slider-val">{globalLimit}%</span>
          <button className="btn btn-primary" onClick={applyGlobal}>Aplicar a todos →</button>
        </div>
      </div>
      <div className="card">
        <div className="card-title">Control individual por bus</div>
        <table>
          <thead>
            <tr><th>Bus / ID</th><th>COP</th><th>SoC actual</th><th style={{width:'140px'}}>Batería</th><th>Límite</th><th>Energía est.</th><th>Estado</th><th>Tiempo est.</th></tr>
          </thead>
          <tbody>
            {buses.map((b,i) => {
              const e = energEst(b.soc, b.limite);
              const col = socColor(b.soc);
              return (
                <tr key={b.id}>
                  <td>
                    <div><span className="badge">{b.id}</span></div>
                    <div style={{fontSize:'11px',color:'#666',marginTop:'2px'}}>{b.nombre}</div>
                  </td>
                  <td style={{color:'#aaa'}}>{b.cop}</td>
                  <td style={{fontWeight:'500',color:col}}>{b.soc}%</td>
                  <td>
                    <div className="soc-bar-bg" style={{position:'relative'}}>
                      <div className="soc-bar-fill" style={{width:`${b.soc}%`,background:col}}></div>
                      <div style={{position:'absolute',top:0,left:`${b.limite}%`,width:'2px',height:'100%',background:'#f87171',transform:'translateX(-50%)'}}></div>
                    </div>
                  </td>
                  <td>
                    <div style={{display:'flex',alignItems:'center',gap:'4px'}}>
                      <input className="limit-input" type="number" min="50" max="100" value={b.limite} onChange={e=>updateLimit(i,e.target.value)} />
                      <span style={{fontSize:'12px',color:'#666'}}>%</span>
                    </div>
                  </td>
                  <td style={{fontWeight:'500'}}>{e>0?`${e} kWh`:<span style={{color:'#444'}}>—</span>}</td>
                  <td>{getTag(b.soc,b.limite)}</td>
                  <td style={{color:'#666'}}>{tiempoEst(e)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
